<p-toast></p-toast>

<div
	*ngIf="loading"
	class="flex align-items-center justify-content-center m-0 p-0"
>
	<p-progressSpinner></p-progressSpinner>
</div>

<div class="card-container" *ngIf="!loading && getUser().role_id === 1">
	<div class="card text-center">
		<h2>{{ data?.users }}</h2>
		<p>Usuarios</p>
		<p (click)="export(1)" class="cursor-pointer"><i class="pi pi-download"></i> Exportar</p>
	</div>

	<div class="card text-center">
		<h2>{{ data?.codes }}</h2>
		<p>Códigos</p>
		<p (click)="export(2)" class="cursor-pointer"><i class="pi pi-download"></i> Exportar</p>
	</div>

	<div class="card text-center">
		<h2>{{ data?.investments }}</h2>
		<p>Inversiones</p>
		<p (click)="export(3)" class="cursor-pointer"><i class="pi pi-download"></i> Exportar</p>
	</div>

	<div class="card text-center">
		<h2>{{ data?.transactions }}</h2>
		<p>Transacciones</p>
		<p (click)="export(4)" class="cursor-pointer"><i class="pi pi-download"></i> Exportar</p>
	</div>
	
	<div class="card text-center">
		<h3 (click)="export()" class="cursor-pointer mt-3"><i class="pi pi-download"></i> Exportar Todo</h3>
	</div>
</div>
<div class="card-container" *ngIf="!loading && getUser().role_id === 1">
	<input
		#fileInput
		type="file"
		accept=".xlsx"
		style="display:none"
		(change)="onFileSelected($event)"
	/>
	<div class="card text-center">
		<h3 (click)="import()" class="cursor-pointer mt-3"><i class="pi pi-download"></i> Importar</h3>
	</div>
</div>

<div *ngIf="!loading" class="text-center mt-4 infoVersion">
	{{versionApp}}
</div>